/**
 * Created by Administrator on 2017/7/2.
 */
import * as actions from './actions.js';
import reducer from './reducer.js';
import view from './views/mycarousel.js';

export {actions, reducer, view};



// WEBPACK FOOTER //
// ./src/Component/MyCarousel/index.js